const SESSION_DURATION = 60 * 60 * 1000;
const ADMIN_SESSION_DURATION = 60 * 60 * 1000;
const SESSION_EXPIRY_KEY = 'session_expiry';
const SESSION_ROLE_KEY = 'session_role';

export const startUserSession = (role = 'user') => {
  const duration = role === 'admin' ? ADMIN_SESSION_DURATION : SESSION_DURATION;
  localStorage.setItem(SESSION_EXPIRY_KEY, String(Date.now() + duration));
  localStorage.setItem(SESSION_ROLE_KEY, role);
};

export const getSessionRole = () => {
  return localStorage.getItem(SESSION_ROLE_KEY) || 'user';
};

export const getUserSessionExpiry = () => {
  const expiry = localStorage.getItem(SESSION_EXPIRY_KEY);
  return expiry ? Number(expiry) : null;
};

export const isUserSessionExpired = () => {
  const expiry = getUserSessionExpiry();
  if (!expiry) return true;
  return Date.now() >= expiry;
};

export const clearUserSession = () => {
  localStorage.removeItem(SESSION_EXPIRY_KEY);
  localStorage.removeItem(SESSION_ROLE_KEY);
};